import * as React from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import employee_axios from "../../views/utilities/employeeaxios";
import {
  Box,
  ButtonBase,
  Card,
  CardContent,
  Grid,
  IconButton,
  Modal,
  TextField,
  Typography,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import RefreshIcon from "@mui/icons-material/Refresh";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

const modalContainerStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "500px",
  backgroundColor: "white",
  borderRadius: "8px",
  zIndex: 1,
  outline: "none",
  margin: "2rem",
  padding: "2rem",
  "& .MuiPaper-root": {
    borderRadius: "8px",
  },
};

// Define the keyframes animation as a string
const rotateKeyframes = `
  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(180deg);
    }
  }
`;

// Inject the keyframes into the document's stylesheet
const styleSheet = document.styleSheets[0];
styleSheet.insertRule(rotateKeyframes, styleSheet.cssRules.length);

const CustomizationSocket = () => {
  const [openModal, setOpenModal] = useState(false);
  const [popData, setPopData] = useState({});
  const [email, setEmail] = useState("");
  const [allUsers, setAllUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const customization = useSelector((state) => state.customization);
  const dispatch = useDispatch();

  useEffect(() => {
    getAllUsers();
  }, []);

const getAllUsers = async () => {
  setLoading(true);
  try {
    // All valid roles according to the API
    const validRoles = [ 3, 4, 5, 6]; // These are the valid role IDs

    const { data } = await employee_axios.get(
      `/users/admin?page=1&limit=1&sortBy=createdAt:desc&role_id=3`,
  
    );
    
    setAllUsers(data);
    console.log(data);
  } catch (error) {
    console.error("Failed to fetch users", error);
  } finally {
    setLoading(false);
  }
};
    const handleOpenModal = (data) => {
    setPopData(data);
    setOpenModal(true);
  };


  const handleCloseModal = () => setOpenModal(false);

  const approveUser = async (userId, email) => {
    const body = {
      // approved: true,
      email: email,
    };

    setEmail("");

    try {
      const response = await employee_axios.patch(
        `/users/admin/approve/${userId}`,
        body
      );
      if (response.data) {
        MySwal.fire({
          icon: "success",
          title: "User Approved Successfully",
          showConfirmButton: false,
          timer: 1500,
          position: "bottom-end",
        }).then(() => {
          getAllUsers();
          handleCloseModal();
        });
      } else {
        MySwal.fire({
          icon: "error",
          title: response.data.message,
          showConfirmButton: false,
          timer: 1500,
          position: "bottom-end",
        });
      }
    } catch (err) {
      console.log(err);
      MySwal.fire({
        icon: "error",
        title: "Something went wrong",
        showConfirmButton: false,
        timer: 1500,
        position: "bottom-end",
      });
    }
  };

  const handleRefresh = async () => {
    setLoading(true);
    try {
      await getAllUsers();
      toast.success("Data updated successfully!", { autoClose: 3000 });
    } catch (error) {
      console.error("Failed to fetch users", error);
      toast.error("Failed to update data", { autoClose: 3000 });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* <ButtonBase
        style={{ marginBottom: 2 }}
        onClick={getAllUsers}
        className={loading ? 'rotate' : ''}
      >
        <RefreshIcon />
      </ButtonBase> */}

      <ButtonBase
        style={{ marginBottom: 2 }}
        onClick={handleRefresh}
        className={loading ? "rotate" : ""}
      >
        {loading ? <CircularProgress size={24} /> : <RefreshIcon />}
      </ButtonBase>

      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        container={() => document.body}
      >
        <Box sx={modalContainerStyle}>
          <IconButton
            onClick={handleCloseModal}
            sx={{
              position: "absolute",
              top: "0.5rem",
              right: "0.5rem",
              zIndex: 9999,
            }}
          >
            <CloseIcon />
          </IconButton>
          <Card variant="elevation">
            <CardContent>
              <Grid container spacing={1} alignItems="center">
                <Grid item>
                  <Typography
                    variant="h5"
                    component="div"
                    sx={{ fontWeight: "bold" }}
                  >
                    Name -
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography variant="h5" component="div">
                    {popData.name}
                  </Typography>
                </Grid>
              </Grid>
              <br />
              <Grid container spacing={1} alignItems="center">
                <Grid item>
                  <Typography
                    variant="h5"
                    component="div"
                    sx={{ fontWeight: "bold" }}
                  >
                    Mobile Number -
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography variant="h5" component="div">
                    {popData.mobile}
                  </Typography>
                </Grid>
              </Grid>
              <br />
              <Grid container spacing={1} alignItems="center">
                <Grid item>
                  <Typography
                    variant="h5"
                    component="div"
                    sx={{ fontWeight: "bold" }}
                  >
                    Private E-mail -
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography variant="h5" component="div">
                    {popData.private_email}
                  </Typography>
                </Grid>
              </Grid>
              <br />
              <Grid container spacing={1} alignItems="center">
                <Grid item>
                  <Typography
                    variant="h5"
                    component="div"
                    sx={{ fontWeight: "bold" }}
                  >
                    Official E-mail -{" "}
                  </Typography>
                </Grid>
                <Grid item>
                  <TextField
                    id="outlined-basic"
                    label="Official Email"
                    variant="outlined"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={!!popData.email}
                  />
                </Grid>
              </Grid>
              <br />

              <Button
                variant="contained"
                onClick={() => approveUser(popData.id, email)}
                style={{ margin: ".5rem" }}
                disabled={!!popData.email}
              >
                Approve
              </Button>

              {popData.email && (
                <h6
                  style={{
                    color: "green",
                    paddingTop: "1.3%",
                    paddingLeft: "5%",
                  }}
                >
                  Already Approved
                </h6>
              )}
            </CardContent>
          </Card>
        </Box>
      </Modal>

      <Grid>
        <Grid item xs={12}>
          {allUsers.length > 0 ? (
            allUsers.map((emp) =>
              !emp.approved ? (
                <Card
                  key={emp.id}
                  variant="outlined"
                  sx={{
                    border: "1.5px solid purple",
                    cursor: "pointer",
                    height: "120px",
                    width: "100%",
                  }}
                  style={{ marginBottom: "10px" }}
                >
                  <CardContent style={{ padding: "8px" }}>
                    <Typography variant="h5" component="div">
                      Name &nbsp;-{" "}
                      {emp.name && emp.name.length > 5
                        ? emp.name.slice(0, 19)
                        : emp.name}
                    </Typography>
                    <Typography variant="h5" component="div">
                      Mobile -{" "}
                      {emp.mobile && emp.mobile.length > 5
                        ? emp.mobile.slice(0, 19)
                        : emp.mobile}
                    </Typography>
                    <Typography variant="h5" component="div">
                      Email &nbsp;-{" "}
                      {emp.private_email && emp.private_email.length > 5
                        ? emp.private_email.slice(0, 19)
                        : emp.private_email}
                    </Typography>

                    <Stack direction="row" spacing={2}>
                      {emp.approved ? (
                        <Button
                          variant="contained"
                          color="success"
                          startIcon={<CheckCircleOutlineIcon />}
                          size="small"
                          style={{ margin: "5px" }}
                        >
                          Verified
                        </Button>
                      ) : (
                        <Button
                          variant="contained"
                          size="small"
                          color="secondary"
                          onClick={() => handleOpenModal(emp)}
                          style={{ float: "right", margin: "5px" }}
                          startIcon={<VisibilityIcon />}
                        >
                          View
                        </Button>
                      )}
                    </Stack>
                  </CardContent>
                </Card>
              ) : null
            )
          ) : (
            <Typography variant="h5" component="div">
              No Users Available
            </Typography>
          )}
        </Grid>
      </Grid>
      <ToastContainer />
    </>
  );
};

export default CustomizationSocket;
